module.exports = __webpack_public_path__ + "img/fundacion.b6eb8261.png";